<template>
  <vjs-modal v-bind="$options.propsData" :title="`Previewing ${entity.name}`" icon="la la-headphones">
    <template slot="body-content">
      <aside class="preview-modal">
        <player-iframe-preview
          :item="entity"
          :show-tools="true"
          :is-feed="isFeed"
          :layout-override="layoutOverride" />
      </aside>
    </template>
    <template slot="body-controls">
      <b-button variant="ss" @click="complete">
        Close
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';
import PlayerIframePreview from "VueComponents/PlayerIframePreview";

export default {
  name: `preview-modal`,
  components: {
    VjsModal,
    PlayerIframePreview,
  },
  mixins: [VjsModalMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    entity: {
      type: Object,
      required: true,
    },
    isFeed: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeText: {
      type: String,
      required: false,
      default: `Close`,
    },
    layoutOverride: {
      type: String,
      required: false,
      default: null,
      validator: function (value) {
        return ['square', 'legacy'].indexOf(value) !== -1;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-modal {
  * {
    margin: 16px 0;
  }
}
</style>
